<div [ngClass]="{ container: true, preview: type === 'preview', open: type === 'open' }" *ngIf="hasCover">
  <div class="cover_hover">
    <p *ngIf="editPermissions" (click)="onClickRemoveCover()">Remove Cover</p>
  </div>
  <img (load)="onCheckImage()" [src]="task.covers[type]"/>
</div>
